import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchOperator = async (id: string) => {
  const response = await queryExecute({
    variables: { id },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query Operator($id: String!) {
        operator(id: $id) {
          id
          firstName
          lastName
          email
          phoneNumber
          textNumber
          language1
          language2
          workerSid
          departments
          registrationCallPriorityOverride
          slackId
          slackWebHook
          slackAlertWebHook
          defaultType
          isDefaultOnly
          closedAt
          slingUserId
          teamLeadId
          isRehireEligible
          suspendedAt
          isSuspended
          isRecordAllCalls
          isEnableRegFlowView
          regCallAudio
          resignationReason
          isVerified
        }
      }
    `),
  });

  return response.data.operator!;
};
